module.exports = __webpack_public_path__ + "static/virtual-traveling-8aba75b4bb36e92401f999dd914e3242.png";